import {useEffect, useState} from "react";
import axios from "axios";
import {DeleteDataTable} from "./DeleteDataTable";
import {useNavigate} from "react-router-dom";
import {Const, REST_URL} from "../../component/const/Const";

export const Template = () => {
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([])
    const [maxCnt, setMaxCnt] = useState(null);
    const [page, setPage] = useState(1); // 현재 페이지
    const [limit, setLimit] = useState(10); // 페이지당 개수
    const baseUrl = REST_URL + "activity_test_template";

    const search = () => {
        const from = (page - 1) * limit;
        const to = from + limit - 1;

        axios.get(baseUrl + '_view', {
            headers: {
                Range: `${from}-${to}`
            }
        }).then(data => {
            setTableData(data.data)
        }).catch(e => {
            console.error("Error", e)
        });
    };

    useEffect(() => {
        search()
    }, []);

    return <main className={`w-full  h-screen overflow-x-scroll`}>
        <button onClick={() => navigate(Const.TEMPLATE.url + '/new')} className='m-4'>생성</button>
        <DeleteDataTable data={tableData}/>
        <div className="flex gap-2 justify-center mt-4">
            <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="px-4 py-2 bg-gray-300 rounded"
            >
                이전
            </button>
            <span className="px-4 py-2">페이지 {page}/{Math.ceil(maxCnt / 10)}</span>
            <button
                onClick={() => {
                    const maxPage = Math.ceil(maxCnt / limit);
                    setPage((prev) => Math.min(prev + 1, maxPage));
                }}
                disabled={page >= Math.ceil(maxCnt / limit)}
                className="px-4 py-2 bg-gray-300 rounded"
            >
                다음
            </button>
        </div>

    </main>
}